export default "__VITE_ASSET__BI4d3kxp__"